<template>
  <div class="fill-height bg pt-5 text-center">
    <v-container class="narrow-container">
      <img :src="src" alt="MESI heart" width="120" class="mx-auto" />
    </v-container>

    <v-container class="white narrow-container">
      <div class="pt-5 px-5">
        <div class="mb-10">
          <div class="display-1 mb-3">{{ $t('dialogThankYou.text1') }} {{ $t('dialogThankYou.text2') }}</div>
          <div class="headline">{{ $t('dialogThankYou.text3') }}</div>
        </div>
        <div>
            <v-btn rounded depressed large color="accent" :to="{ name: 'Start' }">{{ $t('newConfig') }}</v-btn>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'ThankYou',
  metaInfo: {
    // title will be injected into parent titleTemplate
    title: 'ThankYou'
  },
  data: function () {
    return {
      src: require('@/assets/placeholder-mesi.svg')
    }
  }
}
</script>

<style lang="scss" scoped>
.narrow-container {
  max-width: 800px;
}
</style>
